import { HelpBox, HelpBoxHeader } from 'components/v2/help-boxes';
import { ConfirmDialog } from 'primereact/confirmdialog';
import React from 'react';
import MyRadioButton from 'components/controls/MyRadioButton';
import { CheckBoxPanel } from 'styles/v2/Styles.styled';
import styled from 'styled-components';

export type EpdUpdateType = 'update' | 'editorialUpdate';

type Props = {
  visible: boolean;
  updateType: EpdUpdateType;
  onUpdateTypeChange: (value: EpdUpdateType) => void;
  onAccept: () => void;
  onHide: () => void;
};

const UpdateEpdTypeSelectionDialog: React.FC<Props> = ({ visible, updateType, onUpdateTypeChange, onAccept, onHide }) => {
  return (
    <ConfirmDialog
      header={<>Update EPD</>}
      closable={false}
      visible={visible}
      style={{ width: '35rem' }}
      onHide={onHide}
      acceptLabel="Send"
      rejectLabel="Cancel"
      accept={onAccept}
      reject={onHide}
      className="custom-dialog"
      message={
        <StyledContentContainer>
          <HelpBox>
            <HelpBoxHeader>This EPD was approved by the verifier.</HelpBoxHeader>
            <div>
              You are allowed to make only the editorial changes to the verified EPD, such as correcting spelling errors
              without verification.
            </div>
            <div>
              If the EPD information needs updating, whether related to the product or LCA, the EPD must be verified again.
            </div>
          </HelpBox>
          <CheckBoxPanel>
            <MyRadioButton
              inputId="updateMode_update"
              value="update"
              name="updateMode"
              checked={updateType === 'update'}
              onChange={(value) => onUpdateTypeChange(value as EpdUpdateType)}
            />
            <label
              htmlFor={'updateMode_update'}
              style={{ textTransform: 'none', marginLeft: '0.5rem', fontFamily: 'Inter' }}
            >
              The EPD needs verification; I will update the EPD information.
            </label>
          </CheckBoxPanel>
          <CheckBoxPanel style={{ marginTop: '0.5rem' }}>
            <MyRadioButton
              inputId={'updateMode_editorialUpdate'}
              value="editorialUpdate"
              name="updateMode"
              checked={updateType === 'editorialUpdate'}
              onChange={(value) => onUpdateTypeChange(value as EpdUpdateType)}
            />
            <label
              htmlFor={'updateMode_editorialUpdate'}
              style={{ textTransform: 'none', marginLeft: '0.5rem', fontFamily: 'Inter' }}
            >
              The EPD verification is not needed; I will make the editorial update.
            </label>
          </CheckBoxPanel>
        </StyledContentContainer>
      }
    />
  );
};

export default UpdateEpdTypeSelectionDialog;

const StyledContentContainer = styled.div`
  padding: 1rem 2rem 2rem 2rem;
  ${(props) => props.theme.fonts.textSmall}
`;
